/**
 * Which key identifies a user on the `/users/*` routes. There is exactly one:
 * the Cognito `Username`.
 *
 * Every `/users/:id/...` route resolves its path parameter through Cognito —
 * the identity routes (`PUT /users/:id`, `DELETE /users/:id`,
 * `.../reset-password`, `.../regenerate-temp-password`,
 * `.../resend-welcome-email`, `.../permanent-delete`) pass it straight to
 * Cognito as `Username`, and the assignment routes
 * (`GET|PUT /users/:id/customers`, `PUT /users/:id/properties`) pass it to
 * `AdminGetUser` as `Username` to resolve the `sub`. An email only resolves
 * when the pool aliases it, and a federated (Azure Entra) user's username is a
 * provider-prefixed id (`entraid_<email>`), so sending the email threw
 * `UserNotFoundException` on the assignment routes for Metron staff — and, for
 * a Metron user who also has a native duplicate account, could have resolved
 * the wrong account. See MET-3285 (and MET-3238 §7.5 for the earlier split).
 *
 * The list (`GET /users/with-customers`) keys its own Cognito lookups on the
 * `Username` it got back from `ListUsers` (#852), so using the same key here is
 * what makes the per-user read resolve the account the list row represents.
 */

/** The user fields the key is read from. */
export interface UserIdentity {
  username: string;
  email: string;
}

/** The key for every `/users/*` route, forwarded to Cognito as `Username`. */
export function cognitoKey(user: UserIdentity): string {
  return user.username;
}
